jQuery(document).ready(function ($) {
  const urlParams = new URLSearchParams(window.location.search);
  const filters = ['cat', 'theme', 'type', 'sector', 'month', 'department'];

  // Check active classes
  const checkClassCat = function (className) {
    if ($('.formation-card').hasClass(className)) {
      $('.formation-card').removeClass(className);
    }
  };

  const displayError = function (elementCount) {
    let message = $('.error-message');
    if (elementCount === 0) {
      message.addClass('block');
    } else {
      message.removeClass('block');
    }
  };

  const countElement = function () {
    let formationCardsVisible = $('.formation-card:visible').length;
    displayError(formationCardsVisible);
  };

  var scrollDown = function () {
    setTimeout(function () {
      $('html,body').animate(
        {
          scrollTop: $('.ccecqa-formations__container').offset().top - 200,
        },
        'slow'
      );
    }, 700);
  };
  if ($('.ccecqa-formations__container').length) {
    let pageType = $('.ccecqa-formations__container').attr('data-type');

    if (urlParams.has('theme')) {
      let searchTheme = urlParams.get('theme');
      if (pageType === 'formations' || pageType === 'webinaires') {
        setTimeout(function () {
          $('#filter-theme').val(searchTheme).trigger('change');
        }, 700);
      }

      if (pageType === 'evenements') {
        setTimeout(function () {
          $('#filter-type').val(searchTheme).trigger('change');
        }, 700);
      }
    }

    filters.forEach((filter) => {
      $('#filter-' + filter).change(function (event) {
        event.preventDefault();
        checkClassCat('hide-' + filter);
        let inputValue = $(this).val();
        $('.formation-card')
          .not('[data-' + filter + '=' + inputValue + ']')
          .addClass('hide-' + filter);
        countElement();
        scrollDown();
      });
    });

    /*$('#filter-cat').change(function (event) {
      event.preventDefault();
      checkClassCat('hide-cat');
      let inputValue = $(this).val();
      $('.formation-card')
        .not('[data-cat=' + inputValue + ']')
        .addClass('hide-cat');
      countElement();
      scrollDown();
    });

    $('#filter-theme').change(function (event) {
      event.preventDefault();
      checkClassCat('hide-theme');
      let inputValue = $(this).val();
      $('.formation-card')
        .not('[data-theme=' + inputValue + ']')
        .addClass('hide-theme');
      countElement();
      scrollDown();
    });

    $('#filter-type').change(function (event) {
      event.preventDefault();
      checkClassCat('hide-type');
      let inputValue = $(this).val();
      $('.formation-card')
        .not('[data-type=' + inputValue + ']')
        .addClass('hide-type');
      countElement();
      scrollDown();
    });

    $('#filter-sector').change(function (event) {
      event.preventDefault();
      checkClassCat('hide-sector');
      let inputValue = $(this).val();
      $('.formation-card')
        .not('[data-sector=' + inputValue + ']')
        .addClass('hide-sector');
      countElement();
      scrollDown();
    });

    $('#filter-department').change(function (event) {
      event.preventDefault();
      checkClassCat('hide-place');
      let inputValue = $(this).val();
      $('.formation-card')
        .not('[data-place=' + inputValue + ']')
        .addClass('hide-place');
      countElement();
      scrollDown();
    });

    $('#filter-month').change(function (event) {
      event.preventDefault();
      checkClassCat('hide-month');
      let inputValue = $(this).val();
      $('.formation-card')
        .not('[data-month=' + inputValue + ']')
        .addClass('hide-month');
      countElement();
      scrollDown();
    });*/

    $('#reset').click(function () {
      $("a[class*='hide-']").removeClass(function (index, css) {
        return (css.match(/(^|\s)hide-\S+/g) || []).join(' ');
      });
      $('.select-formation option').prop('selected', function () {
        return this.defaultSelected;
      });
      countElement();
    });
  }
});
